package ch.wsl.typings.jspdfAutotable

import org.scalablytyped.runtime.StObject
import scala.scalajs.js
import scala.scalajs.js.`|`
import scala.scalajs.js.annotation.{JSGlobalScope, JSGlobal, JSImport, JSName, JSBracketAccess}

package object mod {
  
  @scala.inline
  def default(
    d: ch.wsl.typings.jspdfAutotable.mod.jsPDFDocument,
    options: ch.wsl.typings.jspdfAutotable.mod.UserOptions
  ): scala.Unit = (ch.wsl.typings.jspdfAutotable.mod.^.asInstanceOf[js.Dynamic].applyDynamic("default")(d.asInstanceOf[js.Any], options.asInstanceOf[js.Any])).asInstanceOf[scala.Unit]
  
  @scala.inline
  def applyPlugin(jsPDF: ch.wsl.typings.jspdfAutotable.mod.jsPDFConstructor): scala.Unit = ch.wsl.typings.jspdfAutotable.mod.^.asInstanceOf[js.Dynamic].applyDynamic("applyPlugin")(jsPDF.asInstanceOf[js.Any]).asInstanceOf[scala.Unit]
  
  type CellHook = js.Function1[
    /* data */ ch.wsl.typings.jspdfAutotable.mod.CellHookData, 
    scala.Unit | scala.Boolean
  ]
  
  type CellInput = scala.Null | java.lang.String | js.Array[java.lang.String] | scala.Double | scala.Boolean | ch.wsl.typings.jspdfAutotable.mod.CellDef
  
  /* Rewritten from type alias, can be one of: 
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.auto
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.wrap
    - scala.Double
  */
  type CellWidthType = ch.wsl.typings.jspdfAutotable.mod._CellWidthType | scala.Double
  
  type Color = (js.Tuple3[scala.Double, scala.Double, scala.Double]) | scala.Double | java.lang.String | ch.wsl.typings.jspdfAutotable.jspdfAutotableBooleans.`false`
  
  type ColumnInput = java.lang.String | scala.Double | ch.wsl.typings.jspdfAutotable.anon.DataKey
  
  type CustomFontType = java.lang.String
  
  type FontType = ch.wsl.typings.jspdfAutotable.mod.StandardFontType | ch.wsl.typings.jspdfAutotable.mod.CustomFontType
  
  type MarginPaddingInput = scala.Double | js.Array[scala.Double] | ch.wsl.typings.jspdfAutotable.anon.Bottom
  
  type Opts = org.scalablytyped.runtime.StringDictionary[java.lang.String | scala.Double]
  
  /* Rewritten from type alias, can be one of: 
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.linebreak
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.ellipsize
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.visible
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.hidden
    - js.Function2[
  / * text * / java.lang.String | js.Array[java.lang.String], 
  / * width * / scala.Double, 
  java.lang.String | js.Array[java.lang.String]]
  */
  type OverflowType = ch.wsl.typings.jspdfAutotable.mod._OverflowType | (js.Function2[
    /* text */ java.lang.String | js.Array[java.lang.String], 
    /* width */ scala.Double, 
    java.lang.String | js.Array[java.lang.String]
  ])
  
  type PageHook = js.Function1[/* data */ ch.wsl.typings.jspdfAutotable.mod.HookData, scala.Unit | scala.Boolean]
  
  type RowInput = org.scalablytyped.runtime.StringDictionary[ch.wsl.typings.jspdfAutotable.mod.CellInput] | ch.wsl.typings.jspdfAutotable.mod.HtmlRowInput | js.Array[ch.wsl.typings.jspdfAutotable.mod.CellInput]
  
  /* Rewritten from type alias, can be one of: 
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.everyPage
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.lastPage
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.never
    - scala.Boolean
  */
  type ShowFootType = ch.wsl.typings.jspdfAutotable.mod._ShowFootType | scala.Boolean
  
  /* Rewritten from type alias, can be one of: 
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.everyPage
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.firstPage
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.never
    - scala.Boolean
  */
  type ShowHeadType = ch.wsl.typings.jspdfAutotable.mod._ShowHeadType | scala.Boolean
  
  /* Rewritten from type alias, can be one of: 
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.auto
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.wrap
    - scala.Double
  */
  type TableWidthType = ch.wsl.typings.jspdfAutotable.mod._TableWidthType | scala.Double
  
  /* Rewritten from type alias, can be one of: 
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.striped
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.grid
    - `ch.wsl.typings`.jspdfAutotable.jspdfAutotableStrings.plain
    - scala.Null
  */
  type ThemeType = ch.wsl.typings.jspdfAutotable.mod._ThemeType | scala.Null
  
  type autoTable = js.Function1[/* options */ ch.wsl.typings.jspdfAutotable.mod.UserOptions, scala.Unit]
  
  type jsPDFConstructor = scala.Any
  
  type jsPDFDocument = scala.Any
}
